import React from 'react';

const Heading = ({ 
  height = '48px', 
  width = '48px', 
  color = '#335262', 
  secondaryColor = '#B3B3B3'
}) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>heading</title>
    <g>
      <path d="M8,35v-3l5.06191-0.4774C13.9517,31.45535,14,31.20187,14,30.25V4H5.23128 C4.53031,4,4.34149,4.06725,4.21474,4.69838L3,9H0V0h33v9h-3l-1.21216-4.30162C28.6611,4.06725,28.46969,4,27.77131,4H19v26.25 c0,0.88979-0.01378,1.14327,0.93809,1.20535L25,32v3H8z" fill={secondaryColor}/>
      <path d="M22,48v-3l5.06191-0.47739C27.9517,44.45535,28,44.20187,28,43.25V17h-8.76872 c-0.70097,0-0.88979,0.06725-1.01653,0.69838L17,22h-3v-9h33v9h-3l-1.21216-4.30162C42.6611,17.06725,42.46969,17,41.77131,17H33 v26.25c0,0.88979-0.01377,1.14328,0.93809,1.20535L39,45v3H22z" fill={color}/>
    </g>
  </svg>
);

export default Heading;
